const MuiTouchRipple = {
  styleOverrides: {
    root: { color: 'transparent' },
  },
};

export default MuiTouchRipple;
